<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField
      :form="formInline"
      :formCtrl="formCtrl"
      @onSearch="onSearch"
      @onReset="onReset"
    >
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table
      ref="table"
      :tableData="tableData"
      :cols="cols"
      :page="page"
      :limit="limit"
      :total="total"
      :showIndex="true"
      :btns="btns"
      :allBtnWidth="allBtnWidth"
      @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange"
    >
      <template slot="isdisplay" slot-scope="params">
        <MySwitch
          :data="params.params"
          :activeValue="'1'"
          :inactiveValue="`2`"
          @onToggle="toggleDisplay"
        ></MySwitch>
      </template>
    </Table>

    <FormDialog
      ref="dialog"
      :title="title"
      :width="'548px'"
      :labelWidth="'110px'"
      :form="mform"
      :rules="mrules"
      :formCtrl="mformCtrl"
      :viewMode="viewMode"
      @onModalSubmit="onModalSubmit"
    ></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "cargoconfiguration",
      breadcrumb: [{ name: "系统设置" }, { name: "货物配置" }],
      formCtrl: [
        {
          label: "",
          keyName: "name",
          placeholder: "请填写货物名称",
          type: "text",
        },
      ],
      cols: [
        { prop: "name", label: "货物名称" },
        { prop: "isdisplay", label: "是否显示", slot: "isdisplay" },
      ],
      allBtnWidth: "100px",
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            // console.log(data)
            this.getItem(data);
            this.showDialog();
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id);
          },
        },
      ],
      title: "添加",
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: "请填写货物名称",
            trigger: "blur",
          },
        ],
      },
      mformCtrl: [
        {
          label: "货物名称",
          keyName: "name",
          err: "请填写货物名称",
          type: "text",
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count;
      if (data && data.length) {
        this.tableData = data.map((v) => {
          const obj = { ...v };
          obj.open = v.isdisplay + "";
          return obj;
        });
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      console.log(id);
      let url = `${this.baseUrl}/upstatus `;
      const params = {
        userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getList(true);
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
    add() {
      delete this.mform.id;
      this.mform = { name: undefined };
      this.title = "添加";
      this.showDialog();
    },
    getItem({ id, name }) {
      this.mform = { ...this.mform, id, name };
      this.title = "修改";
    },
  },
};
</script>

<style lang="less" scoped></style>
